import Blue from '~/core';

new Blue({
  name: 'PrefLocation',
  selector: '.detail__preferred-location',
  setup(preflocation) {
    let locationId =  preflocation.querySelector('svg').id;
    this.$addEvents(preflocation, 'click.prevent enter.prevent', (e) => {
      e.currentTarget.classList.toggle('is-active');
      if(e.currentTarget.classList.contains('is-active')){
        this.$setCookie('prefLocation', locationId, 365);
        console.log(this.$getCookie('prefLocation'));
        this.$getPreferredLocation(this.$getCookie('prefLocation'));
      }
      else{
        this.$setCookie('prefLocation', "", 0);
      }
    });
    if (this.$getCookie('prefLocation') !== undefined) {
      if (this.$getCookie('prefLocation') !== "" && this.$getCookie('prefLocation') === locationId) {
          preflocation.classList.add('is-active');
      }
      else {
        preflocation.classList.remove('is-active');
      }
    } 
    else{
      preflocation.classList.remove('is-active');
    }
  },
});